'use strict';

(()=>{
	'use strict';

	//iziModals

	if( $("#modalOndeComprar").length ){
		$('#modalOndeComprar').iziModal({ width: 1000 });
	}

	if( $("#modalAumentarPlano").length ){
		$('#modalAumentarPlano').iziModal({ width: 850 });
	}

	if($('#modalEnviarLicenca').length ){
		$('#modalEnviarLicenca').iziModal({ width: 620 })
	}


	var devices = [
		{
			'id': 1,
			'name': 'Smartphone 1'
		},
		{
			'id': 2,
			'name': 'Smartphone 2'
		},
		{
			'id': 3,
			'name': 'Smartphone 3'
		}
	];

	var maxDevices = 5;
	var emptySpace;
	var templatePickDevices;
	var templateAddDevices;

	function countDevices() {
		var devicesActives = devices.length;
		$('[devices-actives]').html(devicesActives);
	}

	function listDevices() {
		$('[list-devices]').empty();
		emptySpace = maxDevices - devices.length;

		for (var i = 0; i < devices.length; i++) {
			templatePickDevices =
			'<div class="pick-content" data-smartphone="' + devices[i].id + '">' +
					'<div class="pick-devices">' +
						'<i class="hero-icon icon-phone"></i>' +
						'<span class="pick-devices-name">Smartphone ' + devices[i].id + '</span>' +
						'<a href="#"><i class="fa fa-x"></i> Remover</a>' +
					'</div>' +
			'</div>';

			$(templatePickDevices).appendTo('[list-devices]');
		}

		for (var i = 0; i < emptySpace; i++) {
			templateAddDevices =
			'<div class="pick-content">' +
				'<div class="add-devices">' +
					'<a href="#" data-iziModal-open="#modalEnviarLicenca"><i class="fa fa-plus"></i> Enviar uma licença</a>' +
				'</div>' +
			'</div>';

			$(templateAddDevices).appendTo('[list-devices]');
		}
	}

	listDevices();
	countDevices();


	if($('#modalRemoverLicenca').length ){
		$('#modalRemoverLicenca').iziModal({ width: 620 })

		var deviceActive;

		function removeDeviceManagement() {
			$('[data-smartphone] a').on('click', function(e) {
			   e.preventDefault();

			   deviceActive = $(this).parent().parent().attr('data-smartphone');
			   openModalRemoveDevice(deviceActive);
			});

			function openModalRemoveDevice(device) {
				$('[device-id]').html(device)
				$('#modalRemoverLicenca').iziModal('open');
			}
		}

		removeDeviceManagement()

		$('[remove-device]').on('click', function(e) {
			e.preventDefault();

			removeDevice(deviceActive);
		});


		$('[add-device]').on('click', function(e) {
			e.preventDefault();

			addDevice();
		});





		function removeDevice(device) {
			devices = devices.filter(function(item) { return item.id !== parseInt(device); });

			listDevices();

			$('#modalRemoverLicenca').iziModal('close');

			removeDeviceManagement()
			countDevices()
		}

		var lastId, currentId;

		function addDevice() {
			if(devices.length == 0) {
				lastId, currentId = 1;
			} else {
				lastId = devices[devices.length-1].id;
				currentId = parseInt(lastId + 1);
			}

			devices.push({
				'id': currentId,
				'name': 'Smartphone ' + currentId
			})

			listDevices();
			removeDeviceManagement();
			countDevices();
			$('#modalEnviarLicenca').iziModal('close');
		}
	}

	if($('#modalPlanoSelecionado').length ) {
		$('#modalPlanoSelecionado').iziModal({
			width: 475,
			onClosed: function() {
				$('[plan-name]').removeClass('plan-opened');
			}
		 });

		$('a[open-modal-plan]').on('click', function(e) {
		   e.preventDefault();

			 openModalPlanSelected($(this).attr('open-modal-plan'))
		});

		function openModalPlanSelected(plan) {
			$('[plan-name="' + plan + '"]').addClass('plan-opened');

			$('#modalPlanoSelecionado').iziModal('open');
		}

	}

})();
